$(function () {
	// Replace email input values with trimmed values
	$("input[type='email']").on('blur', function () {
		if ($(this).val()) {
			var trimmedEmailVal = ((<any>$(this)).val()).trim();
			$(this).val(trimmedEmailVal);
		}
	});
	(<any>$('.fancybox')).fancybox({
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350,
		nextEffect: 'fade',
		nextSpeed: 200,
		loop: false
	});
	(<any>$('.iframe')).fancybox({
		type: 'iframe',
		maxWidth: 500,
		fitToView: false,
		width: '90%',
		autoSize: false,
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350
	});
	(<any>$('.inline')).fancybox({
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350,
		nextEffect: 'fade',
		nextSpeed: 200,
		scrolling: 'no',
		autoSize: true
	});
	(<any>$("#a_lightbox")).fancybox({ autoSize: true, scrolling: "no" });

	////// Fans MO API integration START //////

	// const tryAgainMessage = 'Please try again in a few minutes or contact support.'
	// const enterValidEmailMessage = 'Please enter a valid email address.'
	// const isCheckoutPage = window.location.pathname.includes('checkout')
	// const isPaymentPage =window.location.pathname.includes('payment')

	// // Checks if the user is signed by trying to get the user's email address from the session storage
	// const fansSignedEmail = sessionStorage.getItem('fansSignedEmail');

	// // Gets HTML elements
	// const fansSignInLoader = document.querySelector('#fansSignInLoader') as HTMLElement
	// const accesAccount = document.querySelector('.access-account') as HTMLElement
	// const join = document.querySelector('.join') as HTMLElement
	// const loggedIn = document.querySelector('.logged-in') as HTMLElement
	// const fansSignInBtn = document.getElementById('fansSignIn') as HTMLElement
	// const fansLogoutButton = document.getElementById('fansLogout') as HTMLElement
	// const fansEmailInput = document.getElementById('fansEmail') as HTMLInputElement
	// const emailErrorMessageSpan = document.getElementsByClassName('email-error-message')[0] as HTMLSpanElement
	// const emailErrorMessageInputMaterial = document.getElementsByClassName('input-material')[0] as HTMLParagraphElement

	// // If it's not the checkout and is not payment page
	// if (!isCheckoutPage && !isPaymentPage) {

	// 	// If it has a sign in button...
	// 	if (fansSignInBtn) {

	// 		// If the user is signed in...
	// 		if (fansSignedEmail) {

	// 			// Sets the user's email address in the input
	// 			fansEmailInput.value = fansSignedEmail

	// 			// Focus on the input
	// 			fansEmailInput.focus()

	// 			// Waits 0.5 second and then clicks the sign in button
	// 			setTimeout(() => $(fansSignInBtn).trigger('click'), 500)
	// 		}

	// 		// Hides the loader
	// 		fansSignInLoader.style.display = 'none'

	// 		// The click event that will be attached to the sign in button
	// 		const handleSignInClick = () => {
				
	// 			// Gets the email from the input
	// 			const fansEmail = fansEmailInput.value?.trim()

	// 			// If the email is empty...
	// 			if (!fansEmail) {
	// 				if (!emailErrorMessageInputMaterial.className.includes('error')) {
	// 					emailErrorMessageInputMaterial.className += ' error'
	// 				}
	// 				emailErrorMessageSpan.innerText = 'Email is required'
	// 				fansSignInBtn.blur()
	// 				fansEmailInput.focus()
	// 				return
	// 			} else {
	// 				emailErrorMessageInputMaterial.className = emailErrorMessageInputMaterial.className.replace('error', '')
	// 				emailErrorMessageSpan.innerText = ''
	// 			}

	// 			// Encodes special characters
	// 			const encodedFansEmail = encodeURIComponent(fansEmail)

	// 			// Shows the loader, hides the sign in button and disables the input
	// 			fansSignInLoader.style.display = 'unset'
	// 			fansSignInBtn.style.display = 'none'
	// 			fansEmailInput.disabled = true

				// const manApiUrl = (window as any).manApiUrl

				// if (!manApiUrl) {
				// 	console.warn(`Mandarin Oriental's API URL is not defined`)
				// 	return
				// }

	// 			// Calls the AWS Lambda function to get the member name and loyalty level
	// 			fetch(`${manApiUrl}/?email=${encodedFansEmail}`, {
	// 				method: 'GET',
	// 				redirect: 'follow'
	// 			})
	// 				.then(response => {
						
	// 					const status = response.status

	// 					// If something wrong happened in the backend
	// 					if (status >= 500) {
	// 						if (!emailErrorMessageInputMaterial.className.includes('error')) {
	// 							emailErrorMessageInputMaterial.className += ' error'
	// 						}
	// 						emailErrorMessageSpan.innerText = tryAgainMessage
	// 						fansSignInBtn.blur()
	// 						fansEmailInput.focus()
	// 						return
	// 					}

	// 					// Transforms the response to JSON
	// 					response.json()
	// 						.then(result => {

	// 							const {
	// 								name, 
	// 								loyalty, 
	// 								loyaltyName, 
	// 								promoCode, 
	// 								discount, 
	// 								hasAcceptedInvitation, 
	// 								message, 
	// 								error
	// 							} = result
		
	// 							// If the user is a member but didn't accept the invitation
	// 							if (hasAcceptedInvitation === false) {
	// 								if (!emailErrorMessageInputMaterial.className.includes('error')) {
	// 									emailErrorMessageInputMaterial.className += ' error'
	// 								}
	// 								emailErrorMessageSpan.innerText = message
	// 								fansSignInBtn.blur()
	// 								fansEmailInput.focus()
	// 								return
	// 							}
								
	// 							// If there is a loyalty level and promo code...
	// 							if (loyalty && promoCode) {
		
	// 								const promoCodeEncoded = encodeURIComponent(promoCode)
		
	// 								// Sets the promo code cookie
	// 								$.ajax({
	// 									url: 'redirect.aspx',
	// 									type: 'POST',
	// 									cache: false,
	// 									data: `&p=${promoCodeEncoded}`,
	// 									async: true
	// 								})
		
	// 								// Updates the cart processing the promo code
	// 								$.ajax({
	// 									url: 'ajax/promo.aspx',
	// 									type: 'POST',
	// 									cache: false,
	// 									data: `&actionType=CARTUPDATE&processPromoCodes=TRUE&posting=TRUE&promoCode=${promoCodeEncoded}`,
	// 									async: true
	// 								})
		
	// 								// Saves the user's email address in the session storage
	// 								sessionStorage.setItem('fansSignedEmail', fansEmail);
		
	// 								// Sets the welcome message
	// 								const fansNameH4 = document.getElementById('fansName')
	// 								fansNameH4!.textContent = name ? `Hello, ${name}` : `Hello!`
		
	// 								// Sets the discount message
	// 								const savingsParagraph = document.getElementById('savingsMessage')
	// 								const article = (loyaltyName.startsWith('A') || 
	// 												loyaltyName.startsWith('E') || 
	// 												loyaltyName.startsWith('E') || 
	// 												loyaltyName.startsWith('E') || 
	// 												loyaltyName.startsWith('I') ||
	// 												loyaltyName.startsWith('O') ||
	// 												loyaltyName.startsWith('U')) ? 'an' : 'a'
	// 								savingsParagraph!.innerHTML = `Enjoy <span>${discount}%</span> Savings as ${article} ${loyaltyName}.`
		
	// 								// Changes the interface to show the welcome message
	// 								accesAccount.style.display = "none"
	// 								join.style.display = "none"
	// 								loggedIn.style.display = "block"
	// 							} 
								
	// 							// If there isn't a loyalty level and promo code...
	// 							else {
	// 								if (error) console.log(error)
	// 								if (!emailErrorMessageInputMaterial.className.includes('error')) {
	// 									emailErrorMessageInputMaterial.className += ' error'
	// 								}
	// 								emailErrorMessageSpan.innerText = enterValidEmailMessage
	// 								fansSignInBtn.blur()
	// 								fansEmailInput.focus()
	// 								setTimeout(() => { fansEmailInput.value = '', 1000 })
	// 								return
	// 							}
	// 						})
							
	// 						// Something went wrong transforming response into JSON
	// 						.catch((error) => { 

	// 							console.log('error', error)

	// 							// Shows try again error message
	// 							if (!emailErrorMessageInputMaterial.className.includes('error')) {
	// 								emailErrorMessageInputMaterial.className += ' error'
	// 							}
	// 							emailErrorMessageSpan.innerText = tryAgainMessage
	// 							fansSignInBtn.blur()
	// 							fansEmailInput.focus()
	// 						})

	// 				})

	// 				// Something when wrong with the request to AWS Lambda
	// 				.catch(error => {

	// 					console.log('error', error)

	// 					// Shows try again error message
	// 					if (!emailErrorMessageInputMaterial.className.includes('error')) {
	// 						emailErrorMessageInputMaterial.className += ' error'
	// 					}
	// 					emailErrorMessageSpan.innerText = tryAgainMessage
	// 					fansSignInBtn.blur()
	// 					fansEmailInput.focus()
	// 				})
	// 				.finally(() => {
	// 					// Hides the loader, shows the sign in button and enables the input
	// 					fansSignInLoader.style.display = 'none'
	// 					fansSignInBtn.style.display = 'unset'
	// 					fansEmailInput.disabled = false
	// 				})
	// 		}

	// 		// Adds the click event to the sign in button
	// 		fansSignInBtn.addEventListener('click', handleSignInClick)

	// 		// Removes class 'error' if email input has value
	// 		fansEmailInput.addEventListener('input', ((event: InputEvent) => {
	// 			if ((event.target as HTMLInputElement).value) {
	// 				emailErrorMessageInputMaterial.className = emailErrorMessageInputMaterial.className.replace('error', '')
	// 			}
	// 		}))
	// 	}

	// 	// If it has a sign out button...
	// 	if (fansLogoutButton) {

	// 		// The click event that will be attached to the sign out button
	// 		const handleSignOutClick = () => {

	// 			// Removes the user's email address from the session storage
	// 			sessionStorage.removeItem('fansSignedEmail');
				
	// 			// Clean the email input
	// 			fansEmailInput.value = ''

	// 			// Changes the interface to show the email form and sign in button
	// 			accesAccount.style.display = "block"
	// 			join.style.display = "block"
	// 			loggedIn.style.display = "none"
	// 		}

	// 		// Adds the click event to the sign out button
	// 		fansLogoutButton.addEventListener('click', handleSignOutClick)
	// 	}
	// }

	// // If it's checkout page
	// else if (isCheckoutPage) {
	// 	const emailInput = document.getElementById('emailAddress') as HTMLInputElement

	// 	// If the user is signed in...
	// 	if (fansSignedEmail) {

	// 		const firstNameInput = document.getElementById('addressUI_tbBillAddressFirstName') as HTMLInputElement

	// 		// Sets the email address in the email input
	// 		emailInput.value = fansSignedEmail

	// 		// Trigger the change event
	// 		$(emailInput).trigger('change')

	// 		// Focus on the first name input if it exists
	// 		if (firstNameInput) {
	// 			firstNameInput.focus()
	// 		}
	// 	}
	// }
	////// Fans MO API integration END //////
});

//dialogBox
//@Author: Adarsh Kurudi
function dialogBox(dialogObj: DialogObj): void {
	var template = {
		outerWrap: '<div class="overlay signupConfirmationFocusTrap" id="dialogbox" aria-label="Email subscription confirmation" style="" role="dialog"><div class="confirmation email-lightbox"></div></div>',
		closeBtn: '<p><a href="javascript:void(0)" onClick="document.getElementById(\'dialogbox\').style.visibility = \'hidden\';document.getElementById(\'dialogbox\').style.display = \'none\';" class="icon-close" aria-label="Close lightbox"><span style="display:none;">Close</span></a></p>',
		innerMain: '<div class="lb-content" id="title-container" tabindex="-1" aria-labelledby="dialogMain dialogSecondary"><div class="lb-form"><h3 id="dialogMain"></h3>',
		innerSecondary: '<p id="dialogSecondary"></p>',
		confirmBtn: '<input type="button" id="dialogBtn" value="Continue Shopping" onClick="document.getElementById(\'dialogbox\').style.visibility = \'hidden\';document.getElementById(\'dialogbox\').style.display = \'none\';" class="btn-main"/ ></div></div>'
	};
	if (!document.getElementById('dialogbox')) {
		$(template.outerWrap).appendTo('body');
	} else {
		document.getElementById('dialogbox')!.style.display = "";
		document.getElementById('dialogbox')!.style.visibility = "visible";
	}
	$('.confirmation').html(template.closeBtn + template.innerMain + template.innerSecondary + template.confirmBtn);
	$('#dialogMain').text(dialogObj.mainTxt);
	$('#dialogSecondary').text(dialogObj.secondaryTxt);
	$('#dialogBtn').val(dialogObj.btnTxt);
	HAHAccessibility.trapFocus({
		container: ".signupConfirmationFocusTrap",
		closeElement: "#dialogBtn",
		firstElementToFocus: "#dialogBtn"
	});
	$('#dialogbox').on('click', function () {
		$(this).css({
			'visibility': 'hidden',
			'display': 'none	'
		});
	});
}
//End dialogBox

$(function () {

	//Include for JQuery version 1.5 and below
	jQuery.expr.pseudos.focus = function (elem: any) {
		return elem === document.activeElement && (elem.type || elem.href);
	};

	$("form").on('keypress', function (e) {
		if (e.key === 'Enter') {
			if ($("#tSearchString").is(":focus")) {
				$("#searchSubmit").trigger("click");
				return false;
			} else if ($("#sweepsName, #sweepsEmail, #sweepsCheck, #sweepsBonvoyCheck").is(":focus")) {
				$("#sweepsBtn").trigger("click");
				return false;
			} else if ($("#landingPageSweepsName, #landingPageSweepsEmail, #landingPageSweepsCheck, #landingPageSweepsBonvoyCheck, #recaptcha-anchor").is(":focus")) {
				$("#landingPageSweepsBtn").trigger("click");
				return false;
			} else if ($("#emailAddress1").is(":focus")) {
				$("#emailAddress1").trigger('blur');
				$("#emailAddress1btn").trigger("click");
				return false;
			} else if ($("#emailAddress2").is(":focus")) {
				$("#emailAddress2").trigger('blur');
				$("#emailAddress2btn").trigger("click");
				return false;
			} else if ($("#searchUI_tbProductName").is(":focus")) {
				doSearch();
				return false;
			} else if ($("#validationNbr").is(":focus")) {
				$("#validationNbr").trigger('blur');
				$("#btn_apply").trigger("click");
				return false;
			} else if ($("#fansEmail").is(":focus")) {
				$("#fansEmail").trigger('blur');
				$("#fansSignIn").trigger("click");
				return false;
			}
		}
	});
});

$(() => HAHAccessibility.init())